var ButtonStyle;
(function (ButtonStyle) {
    ButtonStyle["PRIMARY"] = "primary";
    ButtonStyle["OUTLINE"] = "outline";
    ButtonStyle["OUTLINE_DANGER"] = "outline-danger";
    ButtonStyle["OUTLINE_SUCCESS"] = "outline-success";
    ButtonStyle["OUTLINE_GREY"] = "outline-grey";
    ButtonStyle["OUTLINE_BLACK"] = "outline-black";
    ButtonStyle["WHITE"] = "white";
    ButtonStyle["OUTLINE_WHITE"] = "outline-white";
    ButtonStyle["GREY"] = "grey";
    ButtonStyle["IMAGE"] = "image";
    ButtonStyle["FROSTED"] = "frosted";
    ButtonStyle["FROSTED_GREY"] = "frosted-grey";
    ButtonStyle["LINK"] = "link";
    ButtonStyle["LINK_BLACK"] = "link-black";
    /** Uses primary color for icon */
    ButtonStyle["LINK_BLACK_ALT"] = "link-black-alt";
    ButtonStyle["LINK_SUCCESS"] = "link-success";
    ButtonStyle["LINK_LIGHT_GREY"] = "link-light-grey";
    ButtonStyle["LINK_DANGER"] = "link-danger";
    ButtonStyle["GHOST"] = "ghost";
    ButtonStyle["GHOST_BLACK"] = "ghost-black";
    ButtonStyle["GHOST_DANGER"] = "ghost-danger";
    ButtonStyle["GHOST_SUCCESS"] = "ghost-success";
    ButtonStyle["DANGER"] = "danger";
    ButtonStyle["TRANSPARENT"] = "transparent";
    ButtonStyle["SUCCESS"] = "success";
})(ButtonStyle || (ButtonStyle = {}));
var ButtonIconAnimation;
(function (ButtonIconAnimation) {
    ButtonIconAnimation["DOWN"] = "down";
    ButtonIconAnimation["LEFT"] = "left";
    ButtonIconAnimation["RIGHT"] = "right";
    ButtonIconAnimation["UP"] = "up";
    ButtonIconAnimation["UP_LEFT"] = "up-left";
    ButtonIconAnimation["UP_RIGHT"] = "up-right";
    ButtonIconAnimation["DOWN_LEFT"] = "down-left";
    ButtonIconAnimation["DOWN_RIGHT"] = "down-right";
})(ButtonIconAnimation || (ButtonIconAnimation = {}));

export { ButtonIconAnimation, ButtonStyle };
